<template>
  <div class="aligner">
    <span>
      <img id="bible" src="./assets/bible.png" />
      <p class="verse">{{ verse }}</p>
      <p class="verse" v-if="reference">Proverbs {{ reference }} (KJV)</p>
      <p class="date">{{ currentDayString }}</p>
      <!-- <p><a href="#"><ion-icon name="share"></ion-icon></a></p> -->
      <br /><br />
    </span>
  </div>
</template>

<script>

import moment from 'moment';

export default {
  name: 'app',
  data () {
    return {
      verse: 'Loading...',
      reference: null,
      currentDayString: '',
      allVerses: null,
      allVerseIndexesShuffled: null,
      seed: 1
    }
  },
  methods: {
    shuffledVerseIndexes: function(verses){
      const numberOfVerses = verses.length;

      // Create list if verse indexes [0,1,2,3,4...]
      let verseIndexes = new Array(numberOfVerses);
      for(let i=0; i<verseIndexes.length; i++){
        verseIndexes[i] = i;
      }

      // Shuffle verse indexes
      return this.shuffle(verseIndexes);
    },
    /**
     * Shuffles array in place. (Adapted from https://stackoverflow.com/a/6274381/1119677)
     * @param {Array} a items An array containing the items.
     */
    shuffle: function(a) {
        var j, x, i;
        for (i = a.length - 1; i > 0; i--) {
            j = Math.floor(this.random() * (i + 1));
            x = a[i];
            a[i] = a[j];
            a[j] = x;
        }
        return a;
    },
    /*
     * Random with seed (adapted from https://stackoverflow.com/a/19303725/1119677)
     */
    random: function() {
        var x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    },
    chooseVerseOfTheDay: function(){
      if(this.allVerseIndexesShuffled === null)
        return;

      const numberOfVerses = this.allVerses.length;

      // Find index of today's verse
      var reference = moment([2019, 0, 1]);
      const absoluteDay = moment().diff(reference, 'days');
      const verseIndexOfTheDay = absoluteDay % numberOfVerses;


      // Now, select that verse
      const selectedVerse = this.allVerses[this.allVerseIndexesShuffled[verseIndexOfTheDay]];

      this.verse = selectedVerse.verse;
      this.reference = selectedVerse.reference;
    },
    setCurrentDay: function(){
      let days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      let months = ['January','February','March','April','May','June','July','August','September','October','November','December'];

      let now = new Date();
      let day = days[ now.getDay() ];
      let month = months[ now.getMonth() ];

      const newDayString = day + " " + month + " " + now.getDate() + ", " + now.getFullYear();

      if(newDayString !== this.currentDayString){
        this.currentDayString = newDayString;
        
        this.chooseVerseOfTheDay();
      }
    }
  },
  mounted () {
    this.setCurrentDay();
    setInterval(this.setCurrentDay, 60000);

    fetch('verses.json').then(response => {
      if(response.status !== 200){
        this.verse = "An error has occurred.";
        return;
      }

      response.json().then(data => {
        this.allVerses = data;
        this.allVerseIndexesShuffled = this.shuffledVerseIndexes(this.allVerses);
        this.chooseVerseOfTheDay();
      });
    }).catch(() => {
      this.verse = "An error has occurred.";
    });
  }
}
</script>
<style>
  :root {
    --ion-toolbar-background-color: #842abf;
    --ion-toolbar-text-color: #FFF;
    --ion-font-family: Arial;
    --ion-background-color: #edf0f5;
  }
  html, body{
    height: 100%;
  }
  body{
    margin: 0;
    padding: 0;
  }
  a{
    color: #842abf;
  }
  ion-content{
    text-align: center;
  }
  img#bible{
    width: 25%;
    display: inline-block;
  }
  .date{
    font-size: 14px;
  }
  .aligner{
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .aligner > span{
    display: block;
    margin: auto 0;
  }
  .verse{
    display: block;
    margin-top: 20px;
    max-width: 75%;
    margin-left: auto;
    margin-right: auto;
  }
  .verse, .verse pre{
    font-family: 'Rock Salt', sans-serif;
  }
  ion-icon{
    font-size: 30px;
  }
</style>